module.exports = __webpack_public_path__ + "static/media/SelfProject.413e93ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/SelfProject.png
// module id = 813
// module chunks = 5